import { Expose } from "class-transformer";

export class UpdateBrandDto {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
